// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__29VSb","tabButton":"Tabs_tabButton__1Wa1y","active":"Tabs_active__30kCD"};